import { axiosBase, errorHandler } from "./axios";

const listPlans = (input: any) => {
    return axiosBase
        .post("/api/v1/plans/list-plan", input)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const createPlan = (input: any) => {
    return axiosBase
        .post("/api/v1/plans/create-plan", input)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
};

const viewPlan = (input: any) => {
    return axiosBase
        .get(`/api/v1/plans/plan-details/${input}`)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
}

const updatePlan = (input: any) => {
    return axiosBase
        .put("/api/v1/plans/update-plan", input)
        .then((response) => response.data)
        .catch((error) => errorHandler(error));
}

export const planService = {
    listPlans,createPlan,viewPlan, updatePlan
};